import { Injectable } from "@angular/core";
import { HateoasResourceOperation } from "@lagoshny/ngx-hateoas-client";
import { ResourceSkill } from "@app/models/rest/resource-skill";

@Injectable({
  providedIn: "root"
})
export class ResourceSkillRestService extends HateoasResourceOperation<ResourceSkill> {
  constructor() {
    super(ResourceSkill);
  }
}
